import React, { useEffect, useState, createContext } from 'react';

const WidthContext = createContext({
  width: window.innerWidth,
  viewSize: null
});

function WidthContextProvider({ children }) {
  const [width, setWidth] = useState(window.innerWidth);
  const [viewSize, setViewSize] = useState();

  useEffect(() => {
    const handleResize = () => {
      const current = window.innerWidth;
      setWidth(current);
      if (current > 767) {
        setViewSize('large');
      } else {
        setViewSize('small');
      }
    };
    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return <WidthContext.Provider value={{ width, viewSize }}>{children}</WidthContext.Provider>;
}

export { WidthContext, WidthContextProvider };
